import { WidgetHeader } from "./WidgetHeader";
import { WidgetContent } from "./WidgetContent";

import "./index.css";

function EmbedWidget(props) {
  return (
    <>
      <WidgetHeader {...props} />
      <WidgetContent {...props} />
    </>
  )
}

export default EmbedWidget;
